import { useTranslation } from 'react-i18next';

import Typography from '~/components/Typography';

import { useWebThemeContext } from '../Layout/Context/useWebThemeContext';

interface Props {
  text: string;
  fontFamily?: string;
}

const CopyrightText = ({ text, fontFamily }: Props) => {
  const year = new Date().getFullYear();
  const { t } = useTranslation();
  const { webTheme } = useWebThemeContext();

  return (
    <Typography weight="light" className="!text-xs" fontFamily={fontFamily} color={webTheme.footer_text_color}>
      {t('footer.copyright_simple', {
        year: year,
        name: text,
      })}
    </Typography>
  );
};

export default CopyrightText;
